export default class ExtensionModel {
  public extensionId: string = ''
  public name: string = ''
  public enabled: boolean = false

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data)
    }
  }
}
